'use client'

export default function ArrowRightLong({ color = '#002A3A', opacity = '1', width = '35', height = '25' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0 12.5H34' stroke={color} strokeOpacity={opacity} />
      <path d='M22.6667 1L34.0001 12.5L22.6667 24' stroke={color} strokeOpacity={opacity} />
    </svg>
  )
}
